/**
 * Truncate text with ellipsis
 * @param text - The text to truncate
 * @param maxLength - Maximum length before truncation (default: 50)
 * @returns Truncated text with ellipsis if needed
 */
function truncateText(text: string, maxLength = 50): string {
  if (text.length <= maxLength) {
    return text;
  }
  return text.slice(0, maxLength - 3) + '...';
}

/**
 * Format tenant ID for display (mask sensitive parts)
 * @param tenantId - The tenant ID to format
 * @returns Masked tenant ID
 */
function formatTenantId(tenantId: string): string {
  if (tenantId.length <= 8) {
    return tenantId;
  }
  const start = tenantId.slice(0, 4);
  const end = tenantId.slice(-4);
  return `${start}****${end}`;
}

/**
 * Format error message for display (remove stack traces, etc.)
 * @param message - The error message to format
 * @returns Cleaned error message
 */
function formatErrorMessage(message: string): string {
  // Remove stack trace if present
  const lines = message.split('\n');
  const cleanMessage = lines[0] || message;

  // Truncate if too long
  return truncateText(cleanMessage, 100);
}

/**
 * Capitalize the first letter of each word in a string (title case)
 * @param text - The text to capitalize
 * @returns Text with first letter of each word capitalized
 */
function capitalizeFirstLetter(text: string): string {
  if (!text) return text;
  return text
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

// Namespace export for convenient usage: stringUtil.truncateText()
export const stringUtil = {
  truncateText,
  formatTenantId,
  formatErrorMessage,
  capitalizeFirstLetter,
} as const;

